import { defineComponent, computed, useListeners, inject, ref, watchEffect } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import UiName from '../ui-name/UiName.vue.js';
import UiValue from '../ui-value/UiValue.vue.js';
import UiAssetClassBadge from '../ui-asset-class-badge/UiAssetClassBadge.vue.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertNotifications",
  props: {
    locale: { type: null, required: true },
    timeOut: { type: Number, required: false, default: 0 },
    limit: { type: Number, required: false, default: 3 }
  },
  emits: ["store-error", "data-load", "close", "on-open-history"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const componentInputs = computed(() => ({
      language: props.locale,
      limit: props.limit
    }));
    const listeners = useListeners();
    const hasOpenHistoryClickListener = Object.prototype.hasOwnProperty.call(listeners, "on-open-history");
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate, numberFormat, dateFormat, textFormat } = localizationSupport;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, storeCleanUp, storeRequestData } = storeModule;
    const enabled = ref(false);
    const timeOutHandle = ref(null);
    const getAssetClass = (item) => {
      var _a;
      return (_a = item.security.assetClass) != null ? _a : void 0;
    };
    const getAlertTypeIcon = (type) => {
      return type === "above" ? "chevron-up" : "chevron-down";
    };
    const getAlertTypeKey = (type) => {
      return type === "above" ? "alert.limitAbove" : "alert.limitBelow";
    };
    const onClose = () => {
      enabled.value = false;
      emits("close");
    };
    const onOpenHistoryClick = () => {
      emits("on-open-history");
    };
    watchEffect(() => {
      if (storeData.value && storeData.value.length > 0) {
        enabled.value = true;
      }
      if (timeOutHandle.value) {
        clearTimeout(timeOutHandle.value);
      }
      if (props.timeOut !== 0) {
        timeOutHandle.value = window.setTimeout(() => {
          enabled.value = false;
        }, props.timeOut * 1e3);
      }
    });
    return { __sfc: true, componentInputs, listeners, hasOpenHistoryClickListener, emits, props, localizationSupport, translate, numberFormat, dateFormat, textFormat, storeModule, storeData, storeCleanUp, storeRequestData, enabled, timeOutHandle, getAssetClass, getAlertTypeIcon, getAlertTypeKey, onClose, onOpenHistoryClick, UiName, UiValue, UiAssetClassBadge, HoistComponent };
  }
});

export { _sfc_main as default };
